export const parameters: IParameters = [
  {
    id: 'LOD',
    name: 'LOD',
    type: 'slider',
    groupId: 'base',
    order: 0,
  },
  {
    id: 'body',
    type: 'picker',
    name: 'Body',
    options: [],
    groupId: 'base',
    order: 1,
  },
];
